import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { AppIcons } from '../../app.icons';
import { MetaDataService } from '../../services/meta-data.service';

@Component({
  selector: 'app-module-header',
  templateUrl: './module-header.component.html',
  styleUrls: ['./module-header.component.scss'],
  standalone: true,
  imports: [ButtonModule, MenuModule, DatePipe, CommonModule],
  providers: [DatePipe]
})
export class ModuleHeaderComponent implements OnInit {
  miIcons = AppIcons;
  @Input() label: string;
  @Input() lastSync: Date = new Date();
  @Input() moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  @Input() showImportExportBtn: boolean = true;
  @Input() showAuditBtn: boolean = false;
  @Input() hideAuditBtn: boolean = true;
  @Input() showLastSync: boolean = false;
  @Input() secondaryBtnLabel: any;
  @Input() showSecondaryBtn: boolean = false;
  @Input() isBtnDisabled: boolean = false;
  @Input() showOrderExportBtn: boolean = false;
  @Input() orderExportBtnLabel: string = '';
  @Input() disableDefaultStyle: boolean = false;
  @Input() zIndex: number = 1;
  @Output() onRefreshList: EventEmitter<void> = new EventEmitter();
  lastSyncTime: any;
  HOUR_MINUTE_FORMAT = this.metaDataService.timeHourFormat;

  @Output() onBtnClick: EventEmitter<any> = new EventEmitter();
  @Output() onSecondaryBtnClickEvent: EventEmitter<any> = new EventEmitter();
  @Output() orderExportBtnClick: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router, private metaDataService: MetaDataService,) {

  }

  ngOnInit() {
    this.lastSyncTime = this.lastSync.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  get customRight(): string {
    return this.disableDefaultStyle ? '30px' : '16px';
  }

  onAdd() {
    this.onBtnClick.emit();
  }

  onSecondaryBtnClick() {
    this.onSecondaryBtnClickEvent.emit();
  }
  
  refreshTime() {
    this.onRefreshList.emit();
    this.lastSync = new Date();
    this.lastSyncTime = this.lastSync.toLocaleTimeString()
  }

}
